// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rules-page-header {
  font-size: 36px !important;
  font-weight: 800 !important;
  color: #373737;
  margin-bottom: 24px !important;
  text-align: center;
}

.rules-page-subheader {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #373737;
  margin-bottom: 24px !important;
  text-align: left;
}

.rules-page-body-title {
  font-size: 24px !important;
  font-weight: 800 !important;
  color: #373737;
  margin-bottom: 16px !important;
  text-align: left;
}

.rules-page-body-text {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #373737;
  margin-bottom: 16px !important;
  text-align: left;
}

.rules-page-text-group {
  max-width: 750px !important;
  margin: 0 auto !important;
  width: 100% !important;
}

@media (max-width: 768px) {
  .rules-page-text-group {
    width: 90% !important;
  }
}
.rules-page-tabs-container {
  max-width: 750px;
  margin: 0 auto 24px;
  width: 90%;
}
@media (min-width: 768px) {
  .rules-page-tabs-container {
    width: 100%;
  }
}

.rules-page-tabs-scroll-container {
  width: 100%;
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}
.rules-page-tabs-scroll-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

.rules-page-tabs {
  display: flex;
  padding: 4px 0;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 100%;
  justify-content: center;
}

.rules-page-tab {
  padding: 8px 16px !important;
  margin: 0 4px !important;
  margin-right: 8px !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  background-color: #f5f5f5 !important;
  color: #373737 !important;
  flex-shrink: 0 !important;
}
@media (min-width: 768px) {
  .rules-page-tab {
    font-size: 16px !important;
    padding: 10px 20px !important;
    margin: 0 8px !important;
  }
}
.rules-page-tab:last-child {
  margin-right: 0 !important;
}
.rules-page-tab:hover {
  background-color: #e0e0e0 !important;
}
.rules-page-tab.active {
  background-color: #373737 !important;
  color: white !important;
}

.rules-page-content {
  max-width: 750px;
  margin: 0 auto;
  width: 90%;
}
@media (min-width: 768px) {
  .rules-page-content {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GameRulesPage/GameRulesPageNew.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;AACJ;;AAEA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,8BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,8BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,8BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,2BAAA;EACA,yBAAA;EACA,sBAAA;AACJ;;AAEE;EACE;IACE,qBAAA;EACJ;AACF;AAEE;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;AAAJ;AAEI;EALF;IAMI,WAAA;EACJ;AACF;;AAEE;EACE,WAAA;EACA,gBAAA;EACA,qBAAA,EAAA,YAAA;EACA,wBAAA,EAAA,gBAAA;AACJ;AACI;EACE,aAAA,EAAA,8BAAA;AACN;;AAGE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,uBAAA;AAAJ;;AAGE;EACE,4BAAA;EACA,wBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,oCAAA;EACA,yBAAA;EACA,yBAAA;AAAJ;AAEI;EAbF;IAcI,0BAAA;IACA,6BAAA;IACA,wBAAA;EACJ;AACF;AACI;EACE,0BAAA;AACN;AAEI;EACE,oCAAA;AAAN;AAGI;EACE,oCAAA;EACA,uBAAA;AADN;;AAKE;EACE,gBAAA;EACA,cAAA;EACA,UAAA;AAFJ;AAII;EALF;IAMI,WAAA;EADJ;AACF","sourcesContent":[".rules-page-header {\n    font-size: 36px !important;\n    font-weight: 800 !important;\n    color: #373737;\n    margin-bottom: 24px !important;\n    text-align: center;\n}\n\n.rules-page-subheader {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #373737;\n    margin-bottom: 24px !important;\n    text-align: left;\n}\n\n.rules-page-body-title {\n    font-size: 24px !important;\n    font-weight: 800 !important;\n    color: #373737;\n    margin-bottom: 16px !important;\n    text-align: left;\n}\n\n.rules-page-body-text {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    color: #373737;\n    margin-bottom: 16px !important;\n    text-align: left;\n}\n\n.rules-page-text-group {\n    max-width: 750px !important;\n    margin: 0 auto !important;\n    width: 100% !important;\n  }\n  \n  @media (max-width: 768px) {\n    .rules-page-text-group {\n      width: 90% !important;\n    }\n  }\n  \n  .rules-page-tabs-container {\n    max-width: 750px;\n    margin: 0 auto 24px;\n    width: 90%;\n    \n    @media (min-width: 768px) {\n      width: 100%;\n    }\n  }\n  \n  .rules-page-tabs-scroll-container {\n    width: 100%;\n    overflow-x: auto;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE and Edge */\n    \n    &::-webkit-scrollbar {\n      display: none; /* Chrome, Safari, and Opera */\n    }\n  }\n  \n  .rules-page-tabs {\n    display: flex;\n    padding: 4px 0;\n    white-space: nowrap;\n    width: fit-content;\n    min-width: 100%;\n    justify-content: center;\n  }\n  \n  .rules-page-tab {\n    padding: 8px 16px !important;\n    margin: 0 4px !important;\n    margin-right: 8px !important;\n    border-radius: 6px !important;\n    font-weight: 600 !important;\n    font-size: 14px !important;\n    cursor: pointer !important;\n    transition: all 0.3s ease !important;\n    background-color: #f5f5f5 !important;\n    color: #373737 !important;\n    flex-shrink: 0 !important;\n    \n    @media (min-width: 768px) {\n      font-size: 16px !important;\n      padding: 10px 20px !important;\n      margin: 0 8px !important;\n    }\n    \n    &:last-child {\n      margin-right: 0 !important;\n    }\n    \n    &:hover {\n      background-color: #e0e0e0 !important;\n    }\n    \n    &.active {\n      background-color: #373737 !important;\n      color: white !important;\n    }\n  }\n  \n  .rules-page-content {\n    max-width: 750px;\n    margin: 0 auto;\n    width: 90%;\n    \n    @media (min-width: 768px) {\n      width: 100%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
